import React, { useMemo } from 'react';
import { Outlet, RouteProps } from 'react-router-dom';
import {
    useAuth0,
    withAuthenticationRequired,
    WithAuthenticationRequiredOptions,
} from '@auth0/auth0-react';
import { useHybridAuth } from './HybdridAuthProvider';
import AuthSpinner from '../AuthSpinner/AuthSpinner';

interface IProtectedRouteProps extends RouteProps {
    withAuthRequiredOptions?: WithAuthenticationRequiredOptions | undefined;
}

const ProtectedRoute: React.FC<IProtectedRouteProps> = ({ withAuthRequiredOptions }) => {
    const { isAuthenticated: isAuth0Authenticated, isLoading: isAuth0Loading } = useAuth0();
    const { isAuthenticated: isTokenAuthenticated, loading: isTokenLoading } = useHybridAuth();

    // Mémorisation du composant enveloppé pour éviter les recréations à chaque rendu
    const WrappedComponent = useMemo(
        () =>
            withAuthenticationRequired(() => <Outlet />, {
                onRedirecting: () => <AuthSpinner />,
                ...withAuthRequiredOptions,
            }),
        [withAuthRequiredOptions],
    );

    // État de chargement global
    if (isAuth0Loading || isTokenLoading) {
        return <AuthSpinner />;
    }

    // Authentification Auth0 réussie
    if (isAuth0Authenticated) {
        return <WrappedComponent />;
    }

    // Authentification par token réussie
    if (isTokenAuthenticated) {
        return (<Outlet />) as any;
    }

    // Aucune authentification - déclenche la redirection Auth0
    return <WrappedComponent />;
};

export default ProtectedRoute;
